import FilterList from '@mui/icons-material/FilterList';
import { Avatar, Divider, Grid, IconButton, Tooltip } from '@mui/material';
import { red } from '@mui/material/colors';
import { TIPO_CONJUNTO_OPCOES_FILTRO } from '@/components/filtros/Filtro';
import { action, computed, makeObservable, observable, reaction, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import StringUtil from '@/util/StringUtil';
import '../../css/botao.css';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import FiltroRapidoRelator from './FiltroRapidoRelator';

class FiltroRapido extends ReactComponent {
    abrirPopover = false;
    abrirPopoverFiltro;
    acabouDeFechar = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirPopover: observable,
            abrirPopoverFiltro: observable,
            acabouDeFechar: observable,
            filtrosComFiltroRapido: computed,
            atualizarQuantidadesFiltros: action,
            calcularQuantidades: action,
            handleClosePopoverFiltro: action,
            handleClickIcone: action,
            handleClickOpcaoFiltro: action,
            handleClickFiltro: action,
            filtrosRapidosOrdenados: computed,
            handleClickIconeFiltro: action,
            handleClosePopoverOpcoes: action,
            renderConteudoPopover: computed
        });

        this.createReaction(
            reaction(
                () => this.store.filtros.filtrosComValor.length,
                () => this.atualizarQuantidadesFiltros()
            )
        );
    }

    componentDidMount() {
        this.atualizarQuantidadesFiltros();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.atualizarQuantidadesFiltros();
    }

    get filtrosComFiltroRapido() {
        let filtros = this.store.filtros.filtrosComFiltroRapido.filter(
            (filtro) => this.isComponenteHabilitado(filtro.idFiltro) && filtro.isHabilitado
        );
        filtros = filtros.slice().sort((f1, f2) => (f1.ordemFiltroRapido > f2.ordemFiltroRapido ? 1 : -1));
        return filtros;
    }

    atualizarQuantidadesFiltros() {
        this.filtrosComFiltroRapido.forEach((filtro) => this.calcularQuantidades(filtro));
    }

    calcularQuantidades(filtro) {
        if (filtro.filtroRapido.opcoes === undefined || filtro.filtroRapido.opcoes.length === 0) {
            filtro.filtroRapido.qtdRegistros = filtro.filtrar(
                this.store.processosSessao,
                filtro.filtroRapido.valor
            ).length;
            filtro.filtroRapido.qtdRegistrosFiltrados = filtro.filtrar(
                this.store.processosFiltrados,
                filtro.filtroRapido.valor
            ).length;
            return;
        }

        let soma = 0;
        let somaComFiltros = 0;
        let opcoes = [];
        let totalizador = filtro.totalizador;
        let totalizadorQtdRegistros = 0;
        let totalizadorQtdRegistrosFiltrados = 0;

        filtro.filtroRapido.opcoes.forEach((opcao) => {
            opcoes.push(opcao.valor);
            opcao.qtdRegistros = filtro.filtrar(this.store.processosSessao, opcao.valor).length;
            opcao.qtdRegistrosFiltrados = filtro.filtrar(this.store.processosFiltrados, opcao.valor).length;

            soma += opcao.qtdRegistros;
            somaComFiltros += opcao.qtdRegistrosFiltrados;

            if (
                totalizador !== undefined &&
                ((!Array.isArray(totalizador) && totalizador === opcao.valor) ||
                    (Array.isArray(totalizador) && totalizador.includes(opcao.valor)))
            ) {
                totalizadorQtdRegistros += opcao.qtdRegistros;
                totalizadorQtdRegistrosFiltrados += opcao.qtdRegistrosFiltrados;
            }
        });

        if (totalizador === undefined) {
            if (filtro.tipoConjuntoOpcoes === TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO) {
                filtro.filtroRapido.qtdRegistros = filtro.filtrar(this.store.processosSessao, opcoes).length;
                filtro.filtroRapido.qtdRegistrosFiltrados = filtro.filtrar(
                    this.store.processosFiltrados,
                    opcoes
                ).length;
            } else {
                filtro.filtroRapido.qtdRegistros = soma;
                filtro.filtroRapido.qtdRegistrosFiltrados = somaComFiltros;
            }
        } else {
            filtro.filtroRapido.qtdRegistros = totalizadorQtdRegistros;
            filtro.filtroRapido.qtdRegistrosFiltrados = totalizadorQtdRegistrosFiltrados;
        }
    }

    handleClosePopoverFiltro = () => {
        this.acabouDeFechar = true;

        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 10);

        if (!this.abrirPopoverFiltro) {
            this.abrirPopover = false;
        }
    };

    handleClickIcone = () => {
        if (!this.acabouDeFechar) {
            this.abrirPopover = true;
        }
    };

    handleClickOpcaoFiltro = (filtro, valor) => {
        let novoValor;
        if (filtro.selecaoMultipla) {
            novoValor = this.getNovoValorFiltroSelecaoMultipla(filtro, valor);
        } else {
            novoValor = filtro.valor !== valor ? valor : undefined;
        }
        this.handleClickFiltro(filtro, novoValor);
    };

    getNovoValorFiltroSelecaoMultipla(filtro, valor) {
        let novoValor;
        let valorFiltro = filtro.valor || [];
        if (valorFiltro.findIndex((val) => val === valor) !== -1) {
            novoValor = filtro.valor.filter((val) => val !== valor);
        } else {
            novoValor = valorFiltro.concat(valor);
        }
        return novoValor;
    }

    handleClickFiltro = (filtro, valor) => {
        let valorAnterior = this.store.filtros[filtro.idFiltro].valor;
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros[filtro.idFiltro].valor = valor;
            this.store.alterandoValorFiltro = false;
        });
        if (this.store.processosFiltrados.length === 0) {
            this.store.filtros[filtro.idFiltro].valor = valorAnterior;
            this.mensagemStore.abrirMensagemInfo(
                'Não há processos para o filtro "' +
                    filtro.label +
                    ': ' +
                    filtro.getDescricao(valor) +
                    '" em conjunto com os demais filtros selecionados'
            );
        }
    };

    get filtrosRapidosOrdenados() {
        return this.store.existeFiltroAtivo
            ? this.filtrosComFiltroRapido.slice().sort((f1, f2) => {
                  if (f1.ativo === f2.ativo) {
                      return f1.ordem - f2.ordem;
                  } else {
                      return f1.ativo ? -1 : 1;
                  }
              })
            : this.filtrosComFiltroRapido.slice().sort((f1, f2) => f1.ordem > f2.ordem);
    }

    corFiltroRapido(filtro) {
        if (filtro.filtroRapido.qtdRegistrosFiltrados > 0) {
            return this.isFiltroSelecionado(filtro) ? red[900] : 'black';
        }
        return 'rgba(0, 0, 0, 0.3)';
    }

    isFiltroSelecionado(filtro) {
        let valorFiltroAtivo = this.store.filtros[filtro.idFiltro].valor;
        if (filtro.filtroRapido.opcoes) {
            return filtro.filtroRapido.opcoes.findIndex((opcao) => opcao.valor === valorFiltroAtivo) > -1;
        }
        return filtro.filtroRapido.valor === valorFiltroAtivo;
    }

    tooltipFiltro(filtro) {
        let labelValor = filtro.getDescricao(filtro.filtroRapido.valor);
        let totalProcessos = filtro.filtroRapido.qtdRegistros;
        let totalProcessosFiltrados = filtro.filtroRapido.qtdRegistrosFiltrados;

        return (
            <div>
                <div style={{ fontSize: '1rem' }}>
                    {'Filtrar ' +
                        StringUtil.substituirPrimeiraLetraPorMinuscula(filtro.label) +
                        (labelValor ? ': ' + labelValor : '')}
                </div>
                <div>{'(Total de processos: ' + totalProcessos + ' / Filtrados: ' + totalProcessosFiltrados + ')'}</div>
            </div>
        );
    }

    tooltipOpcao(filtro, opcao) {
        return (
            <div>
                <div style={{ fontSize: '1rem' }}>{filtro.getDescricao(opcao.valor)}</div>
                <div>
                    {'(Total de processos: ' +
                        opcao.qtdRegistros +
                        ' / Filtrados: ' +
                        opcao.qtdRegistrosFiltrados +
                        ' )'}
                </div>
            </div>
        );
    }

    handleClickIconeFiltro = (filtro) => {
        if (filtro.filtroRapido.qtdRegistrosFiltrados > 0) {
            if (filtro.filtroRapido.opcoes) {
                this.abrirPopoverFiltro = filtro.idFiltro;
            } else {
                let valor = filtro.valor !== undefined ? undefined : filtro.filtroRapido.valor;
                this.handleClickFiltro(filtro, valor);
            }
        }
    };

    handleClosePopoverOpcoes = (event) => {
        this.abrirPopoverFiltro = undefined;
        const element = document.getElementById(`divFiltroRapido${this.observableProps.id}`);

        if (!element?.contains(event.target)) {
            this.abrirPopover = false;
        }
    };

    render() {
        return (
            <div style={{ margin: '3px' }}>
                <Tooltip
                    title={'Filtro rápido'}
                    placement="top-start"
                >
                    <Avatar
                        id={'iconeFiltroRapido' + this.observableProps.id}
                        onClick={this.handleClickIcone}
                    >
                        <FilterList
                            style={{ cursor: 'pointer' }}
                            color={this.store.existeFiltroRapidoAtivo ? 'secondary' : 'primary'}
                        />
                    </Avatar>
                </Tooltip>
                {this.renderPopover()}
            </div>
        );
    }

    renderPopover() {
        return (
            this.abrirPopover && (
                <PopoverSecretaria
                    open={this.abrirPopover}
                    onClose={this.handleClosePopoverFiltro}
                    anchorEl={() => document.getElementById('iconeFiltroRapido' + this.observableProps.id)}
                    placement="bottom"
                >
                    {this.renderConteudoPopover}
                </PopoverSecretaria>
            )
        );
    }

    get renderConteudoPopover() {
        return (
            <div
                id={'divFiltroRapido' + this.observableProps.id}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}
            >
                <Grid
                    container
                    style={{ justifyContent: 'space-between', width: '103px' }}
                >
                    {this.filtrosComFiltroRapido
                        .slice()
                        .map((filtro) => this.renderFiltroRapido(filtro, this.corFiltroRapido(filtro)))}
                </Grid>
                <Divider />
                <FiltroRapidoRelator />
            </div>
        );
    }

    renderFiltroRapido(filtro, cor) {
        return (
            <Grid
                item
                key={this.nextKey}
                style={{ padding: '0px' }}
            >
                <Tooltip
                    placement="top-start"
                    title={this.tooltipFiltro(filtro)}
                >
                    <IconButton
                        id={'icone-' + filtro.idFiltro}
                        onClick={() => this.handleClickIconeFiltro(filtro)}
                        sx={{
                            color: cor,
                            fill: cor,
                            cursor: filtro.filtroRapido.qtdRegistrosFiltrados > 0 ? 'pointer' : 'default'
                        }}
                        size="large"
                    >
                        {filtro.getIconeFiltroRapido ? filtro.getIconeFiltroRapido(cor) : null}
                    </IconButton>
                </Tooltip>
                {this.renderOpcoesFiltroRapido(filtro)}
            </Grid>
        );
    }

    renderOpcoesFiltroRapido(filtro) {
        return (
            filtro.filtroRapido.qtdRegistros > 0 &&
            filtro.filtroRapido.opcoes && (
                <PopoverSecretaria
                    style={{ zIndex: 1310 }}
                    open={this.abrirPopoverFiltro === filtro.idFiltro}
                    onClose={this.handleClosePopoverOpcoes}
                    anchorEl={() => document.getElementById('icone-' + filtro.idFiltro)}
                    placement="right"
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {filtro.filtroRapido.opcoes.slice().map((opcao) => this.renderOpcao(filtro, opcao))}
                    </div>
                </PopoverSecretaria>
            )
        );
    }

    renderOpcao(filtro, opcao) {
        return (
            <Tooltip
                key={this.nextKey}
                placement="top"
                title={this.tooltipOpcao(filtro, opcao)}
            >
                {opcao.qtdRegistrosFiltrados === 0 ? (
                    <span>
                        <IconButton
                            disabled={true}
                            style={{ display: 'flex', alignItems: 'center', padding: '12px', opacity: '0.3' }}
                            size="large"
                        >
                            {filtro.getIconeOpcaoFiltroRapido(opcao.valor)}
                        </IconButton>
                    </span>
                ) : (
                    <IconButton
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '10px',
                            cursor: 'pointer',
                            border:
                                '2px' + (this.isOpcaoSelecionada(filtro, opcao) ? ' dotted ' : ' hidden ') + opcao.cor
                        }}
                        onClick={() => this.handleClickOpcaoFiltro(filtro, opcao.valor)}
                        size="large"
                    >
                        {filtro.getIconeOpcaoFiltroRapido(opcao.valor)}
                    </IconButton>
                )}
            </Tooltip>
        );
    }

    isOpcaoSelecionada(filtro, opcao) {
        if (filtro.selecaoMultipla) {
            return (filtro.valor || []).findIndex((valor) => valor === opcao.valor) !== -1;
        }
        return filtro.valor === opcao.valor;
    }
}

export default inject('stores')(observer(FiltroRapido));
